/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { Loading } from '@components/atoms/Loading';
import { useResetEmail } from '@features/update-email/api/reset-email';
import { useLogout } from '@hooks/useLogout';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

const UpdateEmail = () => {
	const location = useLocation();
	const logout = useLogout();

	const queryParams = new URLSearchParams(
		location.search
	);
	const token = queryParams.get('token') ?? '';

	const hasTriggeredRef = useRef(false);

	const resetEmail = useResetEmail({
		mutationConfig: {
			onSuccess: () => {
				logout();
			},
		},
	});

	useEffect(() => {
		if (!token) return;
		if (hasTriggeredRef.current) return;

		hasTriggeredRef.current = true;

		resetEmail.mutate({ token });
	}, [token]);

	return <Loading />;
};

export default UpdateEmail;
